/*
 * @format
 * @flow
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Divider } from 'sarsaparilla';
import { STATE_READY, STATE_LOADING } from '../../../../ui-lottery/src/utils/async_utils';
import { fetchAccount, enableDeveloperAccess, updateAccount } from '../../actions/account';
import { fetchOrganizations } from '../../actions/organization';
import { AccountProps } from '../../props/account';
import { ApiKeyProps } from '../../props/apiKey';
import { OrganizationProps } from '../../props/organization';
import { getState } from '../../reducers';
import { getAccount } from '../../reducers/accounts';
import { getOrganizations } from '../../reducers/organizations';
import SearchForm from './SearchForm';
import UserDisplay from '../../components/UserAdminPage/UserDisplay';
import { flattenOrgs, orgsToOptions } from '../../utils/organization';

// $FlowFixMe: this file does exist
import * as styles from './UserAdminPage.scss';

type PropTypes = {
    account: {
        account: AccountProps,
        apiKey: ApiKeyProps
    },
    organizations?: OrganizationProps[],
    states: { [key: string]: number },
    fetchOrganizations: Function,
    enableDeveloperAccess: Function,
    fetchAccount: Function,
    updateAccount: Function
};

type StateTypes = {
    account: {
        account: AccountProps,
        apiKey: ApiKeyProps
    }
};

export class UserAdminPage extends Component<PropTypes, StateTypes> {
    state = {
        isEnableSuccessful: false
    }

    componentDidMount() {
        if (this.props.states.organizations !== STATE_READY) {
            this.props.fetchOrganizations();
        }
    }

    enableDeveloperAccess = () => {
        const { accountId, email } = this.props.account.account;

        return this.props.enableDeveloperAccess(accountId)
            .then(() => {
                return this.props.fetchAccount({ query: email });
            })
    };

    updateAccount = (updatedApiKey: ApiKeyProps) => {
        const { email } = this.props.account.account;
        return this.props.updateAccount(updatedApiKey)
            .then(() => {
                return this.props.fetchAccount({ query: email });
            });
    };

    render() {
        const { organizations, states, account } = this.props;
        const orgOptions = orgsToOptions(flattenOrgs(organizations));
        const disabled = states.accounts !== STATE_READY; // states.accounts === STATE_UNLOADED || states.accounts === STATE_LOADING;
        const isLoading = states.accounts === STATE_LOADING;
        return (
            <div className={styles['search-page']}>
                <SearchForm />

                <Divider />

                <UserDisplay
                    account={account}
                    orgOptions={orgOptions}
                    isDisabled={disabled}
                    isLoading={isLoading}
                    isSuccessful={this.state.isEnableSuccessful}
                    onEnable={this.enableDeveloperAccess}
                    onChange={this.updateAccount}
                    dismissNotification={this.dismissNotification} />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    account: getAccount(state),
    organizations: getOrganizations(state),
    states: getState(state, 'accounts', 'organizations')
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchOrganizations,
    fetchAccount,
    enableDeveloperAccess,
    updateAccount
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserAdminPage);
